import React from 'react'
import { Box } from './Box'
import { Typography } from './Typography'
import styled from '../../utils/styled'
import { Anchor } from './Anchor'

const CompanyName = styled.span`
  color: ${props => props.theme.colors.body2};
  font-weight: 600;
  font-size: ${props => props.theme.fontSizes.body2};
`

export const Footer = () => {
  return (
    <Box margin="1rem 0 0" flex flexDirection="column" justifyContent="center" alignItems="center">
      <Anchor href="https://terminslot.de/" target="_blank">
        <Typography variant="body2" margin="0">
          Gebaut für Branchenführer bei <CompanyName>Terminslot.de</CompanyName>
        </Typography>
      </Anchor>
    </Box>
  )
}
